const notificationsKeys = {
  default: ["notifications"],
};

export { notificationsKeys };
